import React, {useState, useRef} from 'react';
import { LogoMamboo } from 'assets';
import { FormInputs } from 'components/FormInputSelect';
import CustomButton from 'components/CustomButton';
import ImageCropper from 'components/ImageCropper';
import "./informasiumum.scss";
import { getCookie } from 'services/cookies';
import { resolvePhotoUrl } from 'utils/photo';

const InformasiUmum = ({photoProfile, addContent, getProfile, isPayload, setIsPayload, styles}) => {
  const [isFormProfile, setIsFormProfile] = useState({
    name: getProfile && getProfile.name ? getProfile.name : '',
    mamboo_id: getProfile && getProfile.mamboo_id ? getProfile.mamboo_id : '',
    ip_base_number: getProfile && getProfile.ip_base_number ? getProfile.ip_base_number : 'I-',
    company_name: getProfile && getProfile.company_name ? getProfile.company_name : '',
    ip_name_number : getProfile && getProfile.ip_name_number ? getProfile.ip_name_number : '',
    person_responsible : getProfile && getProfile.person_responsible ? getProfile.person_responsible : '',
    title : getProfile && getProfile.title ? getProfile.title : '',
    email: getProfile && getProfile.email ? getProfile.email : '',
    profile_photo: resolvePhotoUrl(getProfile && getProfile.profile_photo)
  })
  const [imagePreviewUrl, setImagePreviewUrl] = useState('');
  // Berkas yang baru dipilih, menunggu dipotong. `null` berarti modal tertutup.
  const [cropSource, setCropSource] = useState(null);

  const fileInputRef = useRef(null);
  const validationNumber = /^\d+$/;

  const formatIpBaseNumber = (value) => {
    const digits = value.replace(/\D/g, '').slice(0, 10)
    if (digits.length === 0) return 'I-'
    if (digits.length <= 9) return `I-${digits}`
    return `I-${digits.slice(0, 9)}-${digits.slice(9, 10)}`
  }

  // Berkas pilihan pengguna tidak langsung dipakai: ia melewati pemotongan
  // dulu, supaya yang terkirim ke server persis bagian yang ia tentukan dan
  // bukan foto utuh yang nanti dipotong semaunya oleh `object-fit`.
  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      setCropSource({ file, url: URL.createObjectURL(file) })
    }

    // Dikosongkan supaya memilih berkas yang sama dua kali tetap memicu
    // onChange — kalau tidak, membatalkan potongan lalu memilih foto itu lagi
    // tidak akan membuka modalnya.
    e.target.value = ''
  }

  const closeCropper = () => {
    if (cropSource) URL.revokeObjectURL(cropSource.url)
    setCropSource(null)
  }

  const handleCropConfirm = (croppedFile) => {
    // URL pratinjau sebelumnya dilepas supaya blob-nya tidak menumpuk di
    // memori setiap kali pengguna mengganti foto.
    if (imagePreviewUrl) URL.revokeObjectURL(imagePreviewUrl)

    setImagePreviewUrl(URL.createObjectURL(croppedFile))
    setIsPayload({
      ...isPayload, profile_photo: croppedFile
    })
    closeCropper()
  }

  const handleButtonClick = () => {
    if(fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const onChange = (e) => {
    const {name, value} = e.target
    if (name === "ip_base_number") {
      const formatted = formatIpBaseNumber(value)
      setIsFormProfile({ ...isFormProfile, [name]: formatted })
      setIsPayload({...isFormProfile, ...isPayload, [name]: formatted})
    } else if(name === "ip_name_number" && validationNumber.test(value) || name === "ip_name_number" && value === "") {
      setIsFormProfile({ ...isFormProfile, [name]: value })
      setIsPayload({...isFormProfile, ...isPayload, [name]: value})
    } else if (name !== "ip_name_number") {
      setIsFormProfile({ ...isFormProfile, [name]: value })
      setIsPayload({...isFormProfile, ...isPayload, [name]: value})
    }
  }


  return (
    <>
      <div className="frame" style={styles}>
        <div className="text-informasi">Informasi Umum</div>
        {photoProfile && (
          <div className="container-profile">
            {isFormProfile.profile_photo === "" ? (
              imagePreviewUrl ? (
                <img
                  src={imagePreviewUrl}
                  className="photo-profile-preview"
                  alt="Selected"
                />
              ) : (
                <LogoMamboo className="photo-profile" />
              )
            ) : imagePreviewUrl ? (
              <img
                src={imagePreviewUrl}
                className="photo-profile-preview"
                alt="Selected"
              />
            ) : (
              <img
                src={isFormProfile.profile_photo}
                className="photo-profile-preview"
                alt="PhotoProfile"
                // Foto Google menolak request yang membawa header Referer.
                referrerPolicy="no-referrer"
              />
            )}
            <div className="container-upload">
              <div className="text-wrapper-2">Upload Foto Profile</div>
              {/* Ukurannya tidak lagi menjadi syarat yang harus dipenuhi
                  pengguna: foto apa pun dipotong jadi persegi lewat
                  ImageCropper, lalu disimpan 512 x 512 px (outputWidth-nya).
                  Jadi yang disebutkan di sini adalah hasilnya, bukan tuntutan. */}
              <p className="upload-dengan-ukuran">
                Format PNG atau JPEG. <br />
                512 x 512 px.
              </p>
              <input
                type="file"
                style={{ display: "none" }}
                onChange={handleFileChange}
                ref={fileInputRef}
                accept=".jpg,.jpeg,.png,.webp"
              />
              <CustomButton
                label="Upload Foto"
                color="primary-btn"
                onClick={handleButtonClick}
              />
            </div>
          </div>
        )}
        <div className="content-input">
          <div className="subcontent-input">
            <div className="text-input">
              {getCookie("publisher") == 3 ? "Nama Lengkap" : "Nama Publisher"}
            </div>
            <FormInputs
              placeholder="Isi nama lengkap"
              className="frame-wrapper"
              name="name"
              onChange={onChange}
              value={isFormProfile.name}
            />
          </div>
          <div className="subcontent-input">
            <div className="text-input">ID User</div>
            <FormInputs
              placeholder="-"
              className="frame-wrapper"
              name="mamboo_id"
              value={isFormProfile.mamboo_id}
              isDisabled={true}
            />
          </div>
        </div>
        <div className="content-input">
          <div className="subcontent-input">
            <div className="text-input">IP Base Number</div>
            <div style={{ display: 'flex', width: '100%', border: '1px solid var(--border)', borderRadius: '8px', overflow: 'hidden', background: 'var(--surface-1)' }}>
              <span style={{ background: 'var(--surface-2)', padding: '16px 14px', color: 'var(--text-secondary)', borderRight: '1px solid var(--border)', fontWeight: '600', fontSize: '14px', display: 'flex', alignItems: 'center', userSelect: 'none' }}>I-</span>
              <input
                name="ip_base_number"
                value={isFormProfile.ip_base_number.startsWith('I-') ? isFormProfile.ip_base_number.slice(2) : isFormProfile.ip_base_number}
                onChange={onChange}
                placeholder="000000000-0"
                style={{ border: 'none', outline: 'none', flex: 1, padding: '16px 14px', fontSize: '14px', background: 'transparent' }}
              />
            </div>
          </div>
          <div className="subcontent-input">
            <div className="text-input">*Email</div>
            <FormInputs
              placeholder="Publisher@mail.com"
              className="frame-wrapper"
              name="email"
              onChange={onChange}
              value={isFormProfile.email}
            />
          </div>
        </div>
        {getCookie("publisher") == 3 ? null : (
          <>
            <div className="content-input">
              <div className="subcontent-input">
                <div className="text-input">
                  Nama PT/CV Perusahaan ( sesuai dengan akte )
                </div>
                <FormInputs
                  placeholder="Isi nama populer"
                  className="frame-wrapper"
                  name="company_name"
                  onChange={onChange}
                  value={isFormProfile.company_name}
                />
              </div>
              <div className="subcontent-input">
                <div className="text-input">PA Name Number</div>
                <FormInputs
                  placeholder="Isi IP Name"
                  className="frame-wrapper"
                  name="ip_name_number"
                  onChange={onChange}
                  value={isFormProfile.ip_name_number}
                />
              </div>
            </div>
            <div className="content-input">
              <div className="subcontent-input">
                <div className="text-input">Penanggung Jawab</div>
                <FormInputs
                  placeholder="Isi Penanggung Jawab"
                  className="frame-wrapper"
                  name="person_responsible"
                  onChange={onChange}
                  value={isFormProfile.person_responsible}
                />
              </div>
              <div className="subcontent-input">
                <div className="text-input">Jabatan</div>
                <FormInputs
                  placeholder="Isi Jabatan"
                  className="frame-wrapper"
                  name="title"
                  onChange={onChange}
                  value={isFormProfile.title}
                />
              </div>
            </div>
          </>
        )}
        {addContent}
      </div>

      {/* Area potong dibuat persegi karena foto profil tampil persegi di
          sidebar; dengan rasio yang sama, hasil potongannya tampil utuh tanpa
          dipotong lagi oleh `object-fit`. */}
      <ImageCropper
        isOpen={Boolean(cropSource)}
        src={cropSource?.url}
        fileName={cropSource?.file?.name}
        mimeType={cropSource?.file?.type}
        aspect={1}
        onConfirm={handleCropConfirm}
        onCancel={closeCropper}
      />
    </>
  );
}

export default InformasiUmum